import GetAnalyticsForAdminRequestModelBase from '../_generated/modelBases/get-analytics-for-admin-request-model-base';

export default class GetAnalyticsForAdminRequestModel extends GetAnalyticsForAdminRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
